import AOS from "aos";
import { URLASSOLUTO } from "./variables";
import { scrollToSmoothly } from "./utils";
import axios from "axios";

window.axios = axios;

AOS.init({
    startEvent: "load",
});

document.addEventListener("DOMContentLoaded", function () {
    $(document).on("click", "body.tavola-rotonda .bloccoimgsx", function (e) {
        $("html, body").animate(
            {
                scrollTop: $("#sendcontact").offset().top,
            },
            1000
        );
    });

    // fade out background preloader
    $("#preload").fadeOut();

    $(".tagButton").on("click", function () {
        $(this).toggleClass("unselected");
        const tagid = $(this).data("tagbutton");
        $('.boxNewspaper[data-tag="' + tagid + '"]').toggleClass("hidden");
    });

    // show / hide blocco di testo
    $(".showTesto").on("click", function () {
        $(this).next().toggleClass("selected");
    });

    $(".formWireWork").addClass("hidden");

    $("body").on("change", ".languageselector", function () {
        var languageselected = $(this).find(":selected").data("path");
        if (typeof languageselected !== "undefined") {
            window.location.href = languageselected;
        }
    });

    // scroll form contatti ok
    //console.log(window.location);
    if (window.location.href.indexOf("contattiok")) {
        const contattiDiv = document.querySelector("#contattiOkTarget");
        console.log(contattiDiv);
        if (contattiDiv !== null) {
            const topContatti = contattiDiv.getBoundingClientRect().top;

            setTimeout(() => {
                scrollToSmoothly(topContatti - 100, 500);
                // rimuovo hash per eventuale F5 della pagina
                /* history.pushState(
                    "",
                    document.title,
                    window.location.pathname + window.location.search
                ); */
            }, 300);
        }
    }

    Livewire.hook("element.initialized", (el, component) => {
        console.log(el);
        console.log(component);
    });

    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchmove", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.touchend = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchend", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.mouseup = {
        setup: function (_, ns, handle) {
            this.addEventListener("mouseup", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.mousemove = {
        setup: function (_, ns, handle) {
            this.addEventListener("mousemove", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.mousedown = {
        setup: function (_, ns, handle) {
            this.addEventListener("mousedown", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };

    // 2 slide drag
    const dragger = $(".onDragSlide");
    const divToSlide = $("#divToSlide");
    const divParent = document.querySelector("#divParent");
    let isDragging = false;
    $(".onDragSlide").on("touchstart mousedown", function (event) {
        isDragging = true;
        window.addEventListener("mouseup", mouseUp, false);
        window.addEventListener("mousemove", move, false);
        window.addEventListener("touchend", mouseUp, false);
        window.addEventListener("touchmove", move, false);
        /* window.addEventListener('touchend', mouseUp, false); */
        /* window.addEventListener('touchmove', move(event), false); */
    });

    function mouseUp() {
        console.log("end");
        window.removeEventListener("mouseup", mouseUp, true);
        window.removeEventListener("mousemove", move, true);
        window.removeEventListener("touchend", mouseUp, true);
        window.removeEventListener("touchmove", move, true);
        isDragging = false;
    }

    function move(e) {
        //console.log(e);
        if (isDragging) {
            //console.log(e);

            let bounds = divParent.getBoundingClientRect();
            let clientX = e.clientX;
            if (clientX === undefined) {
                clientX = e.touches[0].clientX; // se l'evento è touch, recupero le coordinate del client da e.touches[0]
            }
            let x = clientX - bounds.x;

            let parentWidth = divParent.offsetWidth;
            let percLeft = (x / parentWidth) * 100;

            if (percLeft > 0 && percLeft < 100) {
                $(dragger).css("left", percLeft + "%");
                $(divToSlide).css("width", percLeft + "%");
            }

            //console.log(e.clientX);
            //console.log(percLeft);
        }
    }

    function scrollTo(element) {
        window.scroll({
            behavior: "smooth",
            left: 0,
            top: element.offsetTop + 250,
        });
    }

    $(".goToFormLavora").on("click", function (event) {
        var dataAttribute = $(this).data("targetwork");
        var selectTargetValue = $(
            '#candidatura option[data-work="' + dataAttribute + '"]'
        ).val();

        console.log(selectTargetValue);

        $("#candidatura").val(selectTargetValue).trigger("change");
        scrollTo(document.getElementById("lavoraFormTarget"));
    });

    // show / hide tabs contatti
    $(".changeTabContattaci").on("click", function () {
        $(".changeTabWork").removeClass("selected");
        $(".formWireWork").addClass("hidden");

        $(".changeTabContattaci").addClass("selected");
        $(".formWireContatti").removeClass("hidden");
    });

    // show / hide tabs lavora con noi
    $(".changeTabWork").on("click", function () {
        $(".changeTabContattaci").removeClass("selected");
        $(".formWireContatti").addClass("hidden");

        $(".changeTabWork").addClass("selected");
        $(".formWireWork").removeClass("hidden");
    });

    // altezza animazioni
    let bodyHeight = document.body.scrollHeight;
    $(".gradient-morph").css("height", bodyHeight / 2);
    /* $(".gradient-morph.v2").css("height", bodyHeight / 2.85); */
    $(".gradient-morph.v3").css("height", "100%");

    window.addEventListener(
        "resize",
        function (event) {
            bodyHeight = document.body.scrollHeight;
            $(".gradient-morph").css("height", bodyHeight / 2);
            /* $(".gradient-morph.v2").css("height", bodyHeight / 2.85); */
            //console.log(bodyHeight);
        },
        true
    );

    //console.log(bodyHeight);

    // slides laboratorio homepage
    $(".showSlideLaboratorio").on("click", function () {
        const dotId = $(this).data("id");
        $(".showSlideLaboratorio")
            .removeClass("slideCentered")
            .removeClass("md:laboratoriSlideshowFlex");
        $(this)
            .addClass("slideCentered")
            .addClass("md:laboratoriSlideshowFlex");

        $(".dotLaboratorio").removeClass("selected");
        $(`#dot${dotId}`).addClass("selected");
    });

    $(".dotLaboratorio").on("click", function () {
        const dotId = $(this).data("id");
        $(".showSlideLaboratorio")
            .removeClass("slideCentered")
            .removeClass("md:laboratoriSlideshowFlex");
        $(`#laboratorio${dotId}`)
            .addClass("slideCentered")
            .addClass("md:laboratoriSlideshowFlex");

        $(".dotLaboratorio").removeClass("selected");
        $(this).addClass("selected");
    });

    let xDown = null;
    let yDown = null;

    $(".showSlideLaboratorio").on("touchstart", function (evt) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    });

    $(".showSlideLaboratorio").on("touchmove", function (evt) {
        if (!xDown || !yDown) {
            return;
        }

        let xUp = evt.touches[0].clientX;
        let yUp = evt.touches[0].clientY;

        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                // left swipe
                let elementId = $(this).data("id") + 1;

                if ($("#laboratorio" + elementId).length > 0) {
                    $(".showSlideLaboratorio")
                        .removeClass("slideCentered")
                        .removeClass("md:laboratoriSlideshowFlex");
                    $("#laboratorio" + elementId)
                        .addClass("slideCentered")
                        .addClass("md:laboratoriSlideshowFlex");
                }
            } else {
                // right swipe
                let elementId = $(this).data("id") - 1;
                if ($("#laboratorio" + elementId).length > 0) {
                    $(".showSlideLaboratorio")
                        .removeClass("slideCentered")
                        .removeClass("md:laboratoriSlideshowFlex");
                    $("#laboratorio" + elementId)
                        .addClass("slideCentered")
                        .addClass("md:laboratoriSlideshowFlex");
                }
            }
        } else {
            if (yDiff > 0) {
                // up swipe
            } else {
                // down swipe
            }
        }
        // reset values
        xDown = null;
        yDown = null;
    });

    function getTouches(evt) {
        return (
            evt.touches || // browser API
            evt.originalEvent.touches
        ); // jQuery
    }

    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
    jQuery.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchmove", handle, {
                passive: !ns.includes("noPreventDefault"),
            });
        },
    };
});
